"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
const initDebug = require("debug");
const _fetch = require("node-fetch");
const range_1 = require("@tokenizer/range"); // Add 'fetch' API for node.js
const debug = initDebug('streaming-http-token-reader:http-client');
const DEFAULT_CONFIG = {
    resolveUrl: false
};
/**
 * Simple HTTP-client, which both works in node.js and browser
 */
class HttpClient {
    constructor(url, config) {
        this.url = url;
        this.config = DEFAULT_CONFIG;
        Object.assign(this.config, config);
    }
    static getContentLength(headers) {
        const contentLength = headers.get('Content-Length');
        return contentLength ? parseInt(contentLength, 10) : undefined;
    }
    static parseContentRange(headers) {
        const contentRange = headers.get('Content-Range');
        return range_1.parseContentRange(contentRange);
    }
    static makeResponse(resp) {
        const contentRange = HttpClient.parseContentRange(resp.headers);
        return {
            url: resp.url,
            size: contentRange ? contentRange.instanceLength : HttpClient.getContentLength(resp.headers),
            mimeType: resp.headers.get('Content-Type'),
            contentRange,
            arrayBuffer: () => resp.arrayBuffer()
        };
    }
    async getHeadInfo() {
        const response = await _fetch(this.url, { method: 'HEAD' });
        if (this.config.resolveUrl)
            this.resolvedUrl = response.url;
        return HttpClient.makeResponse(response);
    }
    async getResponse(method, range) {
        if (range) {
            debug(`_getResponse ${method} ${range[0]}..${range[1]}`);
        }
        else {
            debug(`_getResponse ${method} (range not provided)`);
        }
        const headers = new _fetch.Headers();
        headers.set('Range', 'bytes=' + range[0] + '-' + range[1]);
        const response = await _fetch(this.resolvedUrl || this.url, { method, headers });
        if (response.ok) {
            if (this.config.resolveUrl)
                this.resolvedUrl = response.url;
            return HttpClient.makeResponse(response);
        }
        else {
            throw new Error(`Unexpected HTTP response status=${response.status}`);
        }
    }
}
exports.HttpClient = HttpClient;
